import {
  HomeImageContainer
  , HomeContainer, HomeImage, HomeLoginContainer, FlexBox
} from './styled';
import { Header } from '../../components/header/internals'
import Image from '../../assets/homeimage.svg'


export const AboutUs = () => {
  return (
    <HomeContainer>
      <Header />
      About Us
      {/* <FlexBox > */}
      {/* <HomeImageContainer>
        <HomeImage src={Image} />
      </HomeImageContainer>

      <HomeLoginContainer>

      </HomeLoginContainer>
      </FlexBox> */}

    </HomeContainer>
  );
};
